import { connect } from 'react-redux';
import { UploadProgress } from '@ff-os/shared-react/components/upload-progress/UploadProgress';
import { selectFailedUploadsError } from '@ff-scene-plugins/photo-prints-redux/slices/groupsUiSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectAmountOfUploadsRemaining } from '../_redux-photos';

const mapStateToProps = (state: PhotoPrintsPdpState) => ({
    amountOfUploadsRemaining: selectAmountOfUploadsRemaining(state),
    failedUploadsError: state.project.groups.ids
        .flatMap(id => selectFailedUploadsError(state, id))
});

export const PhotoPrintsUploadProgress = connect(
    mapStateToProps
)(UploadProgress);